import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { BabylonScene } from "@/pages/3d/live/BabylonScene";

export const Route = createFileRoute("/demo/3d/live/babylon-scene")({
  component: () => (
    <BabylonSceneWrapper>
      <BabylonScene />
    </BabylonSceneWrapper>
  ),
});
